module.exports = __webpack_public_path__ + "img/error.4146ff07.svg";